
    <span *ngIf="list.length === 1" class="single-property">{{list[0]}}</span>
    <span *ngIf="list.length > 1">
      <span class="link" [matMenuTriggerFor]="menu">
        <span class="mr-2">Multiple</span>
        <i class="far fa-list-alt"></i>
      </span>
      <mat-menu #menu="matMenu" class="list-only">
        <button mat-menu-item *ngFor="let element of list" class="text-truncate" [disableRipple]="true">{{element}}</button>
      </mat-menu>
    </span>
  